import http from "@/request/http";

const api = {
    // 账户
    account: {
        /**
         * 用户注册
         * @param data
         * @returns {Promise<AxiosResponse<any>>}
         */
        async register(data) {
            return await http.post('/user/register', data)
        },

    },

    //事件
    events:{
        async list(data) {
            return await http.post('/api/v1/event/list', data)
        },
        async detail(event_id) {
            return await http.post('/api/v1/event/detail', {event_id:event_id})
        },
        async update(event_id,status) {
            return await http.post('/api/v1/event/update', {event_id:event_id,status:status})
        },
    },

    // 智能识别
    detect:{
        async detect(file) {
            return await http.postFile('/detect', file)
        },
    }
}

export default api
